import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayRound = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		fill: "#FAED6F",
		r: 36,
		cx: 36,
		cy: 36
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#004B50",
		d: "M54.1012 33.814L26.9012 20.214C26.5952 20.0598 26.2547 19.9868 25.9125 20.002C25.5702 20.0172 25.2375 20.12 24.9464 20.3007C24.6553 20.4814 24.4155 20.7339 24.25 21.0339C24.0845 21.3339 23.9988 21.6713 24.0012 22.014V49.214C23.9889 49.5708 24.0724 49.9243 24.2429 50.238C24.4135 50.5516 24.6649 50.8139 24.971 50.9976C25.2771 51.1813 25.6269 51.2797 25.9839 51.2825C26.3409 51.2854 26.6921 51.1927 27.0012 51.014L54.1012 37.414C54.4393 37.2502 54.7245 36.9945 54.924 36.6761C55.1236 36.3578 55.2294 35.9897 55.2294 35.614C55.2294 35.2383 55.1236 34.8701 54.924 34.5518C54.7245 34.2334 54.4393 33.9777 54.1012 33.814V33.814Z"
	})]
});
export { SvgPlayRound as ReactComponent };
